import { Injectable } from '@angular/core';
import { VersionService } from './version.service';
import { UserService } from './user.service';
import { catchError, concatMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
private redirectUrl!: string;
  constructor(private versionService: VersionService,
private apiService:ApiService

  ) { }

  
init(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.versionService.loadAppVersion().pipe(
        tap(() => {
          const version = this.versionService.getVersion();
        }),
        concatMap(() => this.loadConfig())
      ).subscribe({
        next: () => {          
          resolve();
        },
        error: (err) => {
          console.error('Error during app init:', err);
          reject(err);
        }
      });
    });
  }

  loadConfig(): Observable<any> {
    return this.apiService.get('User/GetLoginConfig').pipe(
      tap((config) => {
        if (config) {
          this.redirectUrl = config;
        } else {
          console.warn('Config returned empty result');
        }
      }),
      catchError((err) => {
        console.error('Failed to load login config:', err);
        return of(null);
      })
    );
  }
  
  
    getLoginUrl() {
      return this.redirectUrl?? "https://connect.age.ohio.gov/";
    }

}
